import { useCallback } from 'react';
import { Header } from 'shared/components/Header';
import { useAppDispatch } from 'shared/hooks';
import { setModalContent } from 'shared/slices';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { logOut } from '@cian/auth';
import { useDeviceType } from '@cian/ui-kit';
import { DEV_CIAN_URL } from 'shared/constants/links';
import { useSelector } from 'react-redux';
import { selectUser } from 'shared/selectors/user';
import { clearLocalStorageByPrefix } from 'shared/hooks/useLocalStorage';

export const HeaderContainer: React.FC = () => {
  const dispatch = useAppDispatch();

  const { user } = useSelector(selectUser);

  const device = useDeviceType();

  const { config } = useApplicationContext();

  const logoutUrl = config.get<string>('b2b-marketing-frontend.logOutBaseUrl') || DEV_CIAN_URL;

  const handleClickBtn = useCallback(async () => {
    if (user) {
      clearLocalStorageByPrefix('door-first-button-clicked-');
      await logOut(logoutUrl);

      window.location.reload();
    } else {
      dispatch(setModalContent({ type: 'authentication' }));
    }
  }, [dispatch, logoutUrl, user]);

  const textBtn = user ? 'Выйти' : 'Войти';

  return <Header onClickBtn={handleClickBtn} btnText={textBtn} device={device} />;
};
